
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gjwnNKSIMd9p5wBm4IbI3FJVn4kMRxROq0Pb6v0Vr4OcMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKOIhuBXW7B0juI_45BLiDOqmmecMZ9xEZX_FdYckZGQyIMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchilGfRevZRR0LGb3kqeBNNrHVRcvpAFomjFPs5ZBRu0YMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexz3uZLyZRyUyZVLIJRBBBC3l0lDJ_45bZwxp_45QdIPUDqyMMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93WKBsAT1u1O3wgp_45ZkO07mJgwyqYNI7hist95X8n0WGkMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index98HEfv7fvaYiIFob3MZJmmgZmuEQDgrFLeSCuOfUtGAMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Ep7TB7ocOsk_45wYESHZZ_oKkjp9BkB0MW8uFtDuYBQwkMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index7K5I_BBFtlivrF_Vw_6iMC4DdozImEsvktWHK6hnnUsMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93yOdpKVmpnjx1On__gq2d0H5KB9Ka2vxUml66r9S5BdYMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexFyImXIs9M9v6C5VOgyYFY2zsfI898fLdidOtwenmr4IMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZdvuSzhfAlxqHKijB82QYsTeez12Yz_45p1wFaeBkQhdwMeta } from "/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index98HEfv7fvaYiIFob3MZJmmgZmuEQDgrFLeSCuOfUtGAMeta || {},
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index7K5I_BBFtlivrF_Vw_6iMC4DdozImEsvktWHK6hnnUsMeta || {},
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexFyImXIs9M9v6C5VOgyYFY2zsfI898fLdidOtwenmr4IMeta || {},
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZdvuSzhfAlxqHKijB82QYsTeez12Yz_45p1wFaeBkQhdwMeta || {},
    component: () => import("/codebuild/output/src1572905240/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]